import * as React from "react"
import { connect } from "react-redux"
import { transformAntTableFilter } from "../filters/utils"
import { getFilters, isStateLoading } from "../filters/selectors"
import { setFilters, setPagination } from "../filters/actions"
import DataTableLegacy from "./DataTableLegacy"
import type { FiltersIdentifier, FiltersObject } from "../filters/types"

type Props = {
    className: string
    components: Record<string, any>
    filters: FiltersObject
    reportIdentifier: FiltersIdentifier
    dataLoading: boolean
    rowKey: string
    pagination?: boolean
    rowClassName?: () => string
    setFilters: (identifier: FiltersIdentifier, filters: FiltersObject) => void
    setPagination: (identifier: FiltersIdentifier, paginationValue: Record<string, any>) => void
}

class ReportDataTable extends React.PureComponent<Props> {
    static defaultProps = {
        className: "",
        pagination: true,
        rowClassName: () => "reportRow",
    }

    render() {
        const {
            filters,
            reportIdentifier,
            dataLoading,
            setFilters: propSetFilters,
            setPagination: propSetPagination,
            ...restProps
        } = this.props
        return (
            <React.Fragment>
                <style jsx={true} global={true}>
                    {`
                        .reportDataTable .reportRow > td {
                            padding: 0.5125rem 0.8125rem;
                        }
                    `}
                </style>
                <DataTableLegacy
                    {...restProps}
                    className={"reportDataTable " + this.props.className}
                    onChange={(pagination, filter, sorter) => {
                        // If changing filter or sorter
                        if (pagination.current === filters.pagination.currentPage) {
                            propSetFilters(reportIdentifier, transformAntTableFilter(filter, sorter))
                        }
                    }}
                    locale={{
                        emptyText: "No data for selected range",
                    }}
                    pagination={
                        this.props.pagination && {
                            onChange: page =>
                                propSetPagination(reportIdentifier, {
                                    currentPage: page,
                                }),
                            current: filters.pagination.currentPage,
                            pageSize: filters.pagination.pageLimit,
                            total: filters.pagination.totalCount,
                        }
                    }
                    loading={dataLoading}
                    rowKey={this.props.rowKey}
                    components={this.props.components}
                    rowClassName={this.props.rowClassName}
                />
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, componentProps) => ({
    filters: getFilters(state, componentProps.reportIdentifier),
    dataLoading: isStateLoading(state, componentProps.reportIdentifier) || componentProps.dataLoading,
})

const mapDispatchToProps = {
    setFilters: setFilters,
    setPagination: setPagination,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(ReportDataTable)
